import actions from './actions'

const state = {
  allSites: [],
  userPreferences: []
}

const getters = {
  allSites: state => state.allSites,
  userPreferences: state => state.userPreferences
}

const mutations = {
  setAllSites(state, response) {
    state.allSites = (response && response.data) ? response.data : []
  },
  setUserPreferences(state, response) {
    state.userPreferences = (response && response.data) ? response.data : []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/sitePreferences/index.js